module.exports = __webpack_public_path__ + "img/2.110c0cf1.jpg";